<template>
  <div>
    <b-row cols="12">
      <h5 class="mt-4">
        Recetas del tratamiento
      </h5>
      </b-row>
      <!-- <b-button variant="outline-primary" @click="showNewPrescriptionModal = true">Añadir receta</b-button> -->
      <b-table class="mt-4" borderless striped hover :items='prescriptionList' :key="index" :fields='table.fields' sort-by.sync="emision">
        <template #cell(images)="row">
          <img :src="row.item.images" alt="row.index" width="50" height="50">
        </template>
        <template #cell(PrescriptionDetail)="row">
          <div class="">
            <p>{{row.item.tradeName}}</p>
            <small>{{row.item.doseNumber }}</small>
          </div>
        </template>
        <template #cell(actions)="row">
          <div class="table-actions-cell">
            <b-icon-trash-fill @click="removeRow(row.index)" class="mr-2" alt="Eliminar"></b-icon-trash-fill>
            <b-button size="sm" @click="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? '-' : '+'}} Info
            </b-button>
          </div>
        </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col sm="3" class="text-sm-right"><b>Age:</b></b-col>
            <b-col>{{ row.item.age }}</b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col sm="3" class="text-sm-right"><b>Is Active:</b></b-col>
            <b-col>{{ row.item.isActive }}</b-col>
          </b-row>

          <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
        </b-card>
      </template>
      </b-table>
  <div class="col-12 text-center align-items-center" v-if="prescriptionList.length==0">
  <h5>Todavia no ha añadido ninguna receta.</h5>
  </div>
  <div class="col-12 text-center align-items-center">
  <b-button variant="outline-primary" @click="showNewPrescriptionModal = true">Añadir receta</b-button>
  </div>
<b-row cols="12">
      <h5 class="mt-4">
        Datos del tratamientonodofarma
      </h5>
      </b-row>
    <b-row cols="5" class="mt-4">
      <b-col>
        <label for="doseFrequency">Duración del tratamiento:</label>
        <base-spin-input
        id="lifespan"
          v-model="newPrescription.lifespan"
          min="0"
          max="20"
          step="1"
        ></base-spin-input>
      </b-col>
      <b-col class="ml-2">
        <label for="frequencyUnity">Medida de duración:</label>
        <base-select v-model="newPrescription.lifespanUnity" label="text" :options="lifespanUnityOptions" :dataAttributes="[{ key: 'key', value: 'label'}]"></base-select>
      </b-col>
    </b-row>
    <b-row cols="12" class="mt-2">
      <b-col>
      <small>
        <b-icon icon="exclamation-circle" variant="dark"></b-icon> La duración máxima del tratamiento es de 12 meses.</small>
      </b-col>
    </b-row>
    <b-row cols="12" class="mt-2">
      <b-col>
         <base-textarea :label="$t('nodofarma.treatment.observations')" v-model="newPrescription.observations" :rows=3 :maxRows=9 ></base-textarea>
      </b-col>
    </b-row>
<!-- Dialogo para eliminar receta         -->
    <base-dialog v-model="dialogConfirmDeletePrescriptionVisible" :okFn="okFn" :cancelFn="cancelFn"
      @toggle="dialogConfirmDeletePrescriptionVisible = !dialogConfirmDeletePrescriptionVisible"
      okBtnText = "Aceptar"
      cancelBtnText = "Cancelar"
      content="¿Desea borrar realmente la receta?">
    </base-dialog>
<!-- Dialogo para añadir receta -->
    <b-modal id="modal-1" v-model="showNewPrescriptionModal" title="Nueva receta">
      <Prescription  ref="customPrescription"></Prescription>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" @click="insertPrescription">Añadir</b-button>
          <b-button variant="danger" @click="showNewPrescriptionModal=false">Cancelar</b-button>
        </div>
      </template> 
    </b-modal>
  </div>
</template>
<script>
import Prescription from '@/components/webapp/professional/prescription.vue'
import {
  BIcon,
  BIconTrashFill,
  BIconPrinterFill,
  BIconFileEarmarkText,
  BIconEnvelope,
  BIconTelephone,
  BIconExclamationCircle,
  BRow, BCol, BFormTextarea, BFormSelect, BFormSpinbutton, BInputGroup, BFormGroup, BInputGroupText, BModal, BFormInput, BButton, BTable
} from 'bootstrap-vue'

export default {
  components: {
    Prescription,
    'base-dialog': () => import('@/components/base/BaseDialog'),
    'base-select': () => import('@/components/base/forms/BaseSelect.vue'),
    'base-textarea': () => import('@/components/base/forms/BaseTextarea.vue'),
    'base-spin-input': () => import('@/components/base/forms/BaseSpinInput.vue'),
    BIcon,
    BIconTrashFill,
    BIconPrinterFill,
    BIconFileEarmarkText,
    BIconEnvelope,
    BIconTelephone,
    BIconExclamationCircle,
    BRow,
    BCol,
    BFormTextarea,
    BFormSelect,
    BFormSpinbutton,
    BInputGroup,
    BFormGroup,
    BInputGroupText,
    BModal,
    BFormInput,
    BButton,
    BTable
  },
  data () {
    return {
      dialogConfirmDeletePrescriptionVisible: false,
      dialogConfirmDeletePrescriptionIndex: null,
      showNewPrescriptionModal: false,
      table: {
        fields: [
          { key: 'images', label: '' },
          { key: 'doseNumber', label: 'Envases' },
          { key: 'PrescriptionDetail', label: 'Producto' },
          { key: 'treatmentStartDate', label: 'Inicio' },
          { key: 'treatmentStartDate', label: 'Fin' },
          { key: 'actions', label: '' }
        ]
      },
      prescriptionList: [
        {
          images: 'https://cdn.auth0.com/blog/vuejs/vue-logo.png',
          dispensingDate: '2021-10-27',
          treatmentStartDate: '2021-11-03',
          treatmentEndDate: '2021-11-03',
          doseNumber: '1',
          doseUnity: 'COMPRIMIDO',
          doseFrequency: '8',
          frequencyUnity: 'HORAS',
          packagesNumber: '1',
          administrationRoute: 'VÍA ORAL',
          dosage: '1.000 mg',
          tradeName: 'PARACETAMOL ABAMED 1 G COMPRIMIDOS EFG'
        }
      ],
      medicationList: [],
      newPrescription: {
        lifespan: 7,
        lifespanUnity: 1
      },
      patientTypes: [
        { value: '1', text: 'Adulto' },
        { value: '2', text: 'Menor' },
        { value: '3', text: 'Lactante' }
      ],
      lifespanUnityOptions: [
        { value: '1', text: 'Dias' },
        { value: '2', text: 'Semanas' },
        { value: '3', text: 'Meses' }
      ],
      patient: {
        type: 1,
        idType: 'Dni',
        idNumber: '28615460X',
        completeName: 'Francisco Luis Velasco Reina',
        birdDate: '27/07/1975',
        age: '45 años',
        email: 'pacolvr@gmail.com',
        contactPhone: '656373696'
      }
    }
  },
  methods: {
    sendPrescription () {
      // this.$nodofarmaApi.post('Tratamiento/CreateTratamiento', this.prescriptionList)
    },
    insertPrescription () {
      this.prescriptionList.push(this.$refs.customPrescription.newMedication)
      this.showNewPrescriptionModal = false
    },
    okFn () {
      if (this.dialogConfirmDeletePrescriptionIndex != null) {
        this.prescriptionList.splice(this.dialogConfirmDeletePrescriptionIndex, 1)
        this.dialogConfirmDeletePrescriptionIndex = null
        this.print()
      }
    },
    cancelFn () {
      this.dialogConfirmDeletePrescriptionIndex = null
    },
    removeRow (index) {
      this.dialogConfirmDeletePrescriptionVisible = true
      this.dialogConfirmDeletePrescriptionIndex = index
    }
  }
}
</script>

<style lang="less">
  .b-icon.bi {
    cursor: pointer;
  }
body {
  text-align:left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/webapp/professional/treatment.vue